/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import { isAxiosError } from 'axios';

export const isRetryableError = (_failureCount: number, error: unknown) => {
  if (isAxiosError(error)) {
    const status = error.response?.status;
    const isQuotaExceeded = status === 503 || status === 429;
    return isQuotaExceeded;
  }
  return false;
};
